import type { MedicationSetting } from "./entities";

/** How many names to offer: enough to be useful, few enough that iOS's popover does not cover the field. */
export const SUGGESTION_LIMIT = 3;

/**
 * Known medicines that complete what the user has typed so far, in the order the
 * list arrives (configured first, then most recently used). Names starting with the
 * text come before names merely containing it; an exact match needs no suggestion.
 */
export function suggestMedicines(known: MedicationSetting[], query: string, limit = SUGGESTION_LIMIT): MedicationSetting[] {
  const q = query.trim().toLowerCase();
  const seen = new Set<string>();
  const unique = known.filter((m) => {
    const key = m.name.trim().toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  if (unique.some((m) => m.name.trim().toLowerCase() === q)) return [];
  const starts = unique.filter((m) => m.name.toLowerCase().startsWith(q));
  const contains = unique.filter((m) => !starts.includes(m) && m.name.toLowerCase().includes(q));
  return [...starts, ...contains].slice(0, limit);
}

/** The stored spelling of a name the user typed, or the text unchanged when it is new. */
export function canonicalMedicineName(known: MedicationSetting[], typed: string): string {
  const match = known.find((m) => m.name.trim().toLowerCase() === typed.trim().toLowerCase());
  return match ? match.name : typed;
}
